import moment from "moment";
import { appConfig } from "../../configs";
import { IViewCustomer } from "../../interfaces-and-types";
import { CopyButton } from "../../components";

export const customersDisplayFormatter = (item: IViewCustomer) => {
  return {
    ...item,
    email: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.email}>{item.email}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            // name="copy-customer-button"
            stringToCopy={item.email}
            iconDescription="copy customer email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    full_name: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.full_name}>{item.full_name || "(anonymous)"}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            // name="copy-customer-button"
            stringToCopy={item.full_name || ""}
            iconDescription="copy customer name"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    phone_number: !item.phone_number ? (
      "..."
    ) : (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.phone_number}>{item.phone_number}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            stringToCopy={item.phone_number}
            iconDescription="copy customer phone"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    // more: <OverflowMenuVertical />,
  };
};
